import { Interval } from 'date-fns';

export function isInterval(value: unknown): value is Interval {
  return !!(
    value &&
    typeof value === 'object' &&
    'start' in value &&
    'end' in value &&
    !('inclusiveEnd' in value) &&
    !('inclusiveStart' in value)
  );
}
